export default "__VITE_ASSET__BP_qv_e$__"